module.exports = __webpack_public_path__ + "img/zhAward-1.018cfaf7.png";